import {useQuery} from "@tanstack/react-query";
import {listExpedientsQueryOptions} from "./list-expedients.query-options";
import type {ListExpedientsSearchInput} from "./list-expedients.schema";

export function useListExpedients(rawInput: ListExpedientsSearchInput) {
  return useQuery(listExpedientsQueryOptions(rawInput));
}
